import { LogContent } from '@/components/play/GameLog/LogContent.tsx'
import { CardContent } from '@/components/ui/card'
import type { TextLogSpeechReference } from './speech-references'

export function GameLogInMarkdown({
  log,
  speechReferences,
  scopeKey,
}: {
  log: string
  speechReferences: readonly TextLogSpeechReference[]
  scopeKey: string
}) {
  return (
    <CardContent className="min-h-0 flex-1 p-0">
      <LogContent
        content={log}
        speechReferences={speechReferences}
        scopeKey={scopeKey}
      />
    </CardContent>
  )
}
